import './LoadingTips.js'; // aiLoadingTips 컴포넌트 정의 파일 임포트
import { trace, nine } from "@ninebone/util";

class TipPopup extends HTMLElement {
	#ideLoadingTipsInstance = null; // aiLoadingTips 인스턴스를 저장할 변수
	#tipsUrl = `https://cdn.jsdelivr.net/npm/@ninebone/ai@${__APP_VERSION__}/dist/tips/tip.json`;
	#tipCategory = 'componentTips';
	#host;

	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {

		this.#host = this.getRootNode().host;

		const customImport = nine.cssPath ? `@import "${nine.cssPath}/nine-ai.css";` : "";

		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/@ninebone/ai@${__APP_VERSION__}/dist/css/nine-ai.css";
				${customImport}
			</style>
			
			<nx-dialog>
				<div class="dialog-content"></div>
			</nx-dialog>
       `;

		this.#init();
	}

	#init = () => {
		// nx-dialog가 DOM에 추가된 후 내부 요소에 접근
		const dialog = this.shadowRoot.querySelector('nx-dialog');
		if (dialog) {
			// dialog가 닫힐 때 aiLoadingTips의 애니메이션 중지
			dialog.addEventListener('close', () => {
				if (this.#ideLoadingTipsInstance) {
					this.#ideLoadingTipsInstance.stopTips();
					// 팝업이 닫힐 때 aiLoadingTips 인스턴스 제거 (선택 사항)
					this.#ideLoadingTipsInstance.remove();
					this.#ideLoadingTipsInstance = null;
				}
			});
		}
	}

	/**
	 * 팁 팝업을 표시하고 aiLoadingTips를 시작합니다.
	 * @param {string} [category='componentTips'] - 표시할 팁의 카테고리 ('componentTips' 또는 'generalAITips')
	 * @param {string} [tipsUrl='/data/tips.json'] - 팁 JSON 파일의 URL
	 */
	async popup() {
		//this.#tipCategory = category;
		//this.#tipsUrl = tipsUrl;
		//trace.log("Popup 시점 CSS Path:", nine.cssPath);

		const dialogContent = this.shadowRoot.querySelector('.dialog-content');
		if (!dialogContent) {
			trace.error("Popup content container not found.");
			return;
		}

		// 기존 aiLoadingTips 인스턴스가 있다면 제거
		if (this.#ideLoadingTipsInstance) {
			this.#ideLoadingTipsInstance.stopTips();
			this.#ideLoadingTipsInstance.remove();
			this.#ideLoadingTipsInstance = null;
		}

		// 새로운 aiLoadingTips 인스턴스 생성 및 추가
		this.#ideLoadingTipsInstance = document.createElement('nine-ai-loading-tips');
		dialogContent.appendChild(this.#ideLoadingTipsInstance);

		// 팁 로딩 시작
		await this.#ideLoadingTipsInstance.startTips(this.#tipsUrl, this.#tipCategory);

		// nx-dialog 팝업 표시
		this.shadowRoot.querySelector('nx-dialog')?.showModal();
	};

	/**
	 * 팁 팝업을 닫습니다.
	 */
	close = () => {

		this.#ideLoadingTipsInstance.stopTips();
		this.shadowRoot.querySelector('nx-dialog')?.close();
		// close 이벤트 리스너에서 aiLoadingTips 정리 로직이 실행될 것임
	};
}

if (!customElements.get("nine-ai-tip-popup")) {
	customElements.define("nine-ai-tip-popup", TipPopup);
}